import { FC, memo } from "react";

import * as S from './styles'
import { TableProps } from "./table.model";

export const Table:FC<TableProps> = memo(({
    tableData,
    backgroundHeader = 'blue-background-strong-default', 
    backgroundData = 'blue-background-hover'
}) => (
    <S.Wrapper backgroundHeader={backgroundHeader} backgroundData={backgroundData}>
        <thead>
            <tr>
            {tableData.headers.map((header, index) => (
                <th key={index}>{header}</th>
            ))}
            </tr>
        </thead>
        <tbody>
            {tableData.content.map((rowData, indexR) => (
                <tr key={indexR}>
                    {rowData.map((data, indexD) => (
                        <td key={indexD}>{data}</td>
                    ))}
                </tr>
            ))}
        </tbody>
    </S.Wrapper>
))

Table.displayName = 'Table'